import styled from "@emotion/styled";


export const Row = styled.div`
    display: grid;
    grid-template-columns: auto 1fr 50%;
    width: 100%;
    align-items: center;
    column-gap: 8px;
`;

export const Pill = styled.div`
    width: 9px;
    height: 4px;
    border-radius: 10px;
    background-color: #B1D8FF;
`;

export const Name = styled.span`
    font-weight: 400;
`;

